export const userType = {
  user: 'Usuário',
  concierge: 'Porteiro',
  syndicate: 'Sindíco',
  dweller: 'Morador',
  tenant: 'Inquilino'
}

export const getOptionsStatus = () => {
  return Object.keys(status).map((key) => {
    return {
      id: key,
      label: status[key]
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/resources/dataType.js